/* eslint-disable no-undef */
<template>
  <div
    v-if="initialData && initialData.length > 0"
    :class="direction === 'across' ? 'dt-bodan-box' : ''"
  >
    <section class="dt-playlist dt-bodan-box-wrap">
      <h3 class="dt-bodan-tit">
        相关播单(共{{ initialData.length }}个)
      </h3>
      <div
        class="search-bodan-list"
        :class="direction !== 'across' ? 'vertical-bodan-list' : ''"
      >
        <div
          v-for="value in initialData"
          :key="value.url"
          class="search-dt-playlist-wrap"
          :class="direction === 'across' && initialData.length > 1 ? 'dt-playlist-wrap-across' : ''"
          :uigs="value.url"
          @click="clickout(value.url)"
        >
          <div
            v-if="value.picurls"
            class="dt-playlist-img"
          >
            <div
              v-if="value.picurls[0]"
              class="img-one"
            >
              <img
                v-lazy="value.picurls[0]"
                alt
              >
            </div>
            <div
              v-if="value.picurls[1]"
              class="img-two"
            >
              <img
                v-lazy="value.picurls[1]"
                alt
              >
            </div>
            <div
              v-if="value.picurls[2]"
              class="img-three"
            >
              <img
                v-lazy="value.picurls[2]"
                alt
              >
            </div>
            <div class="tag-playlist">
              共{{ value.quantity }}部
            </div>
          </div>
          <div class="dt-playlist-info">
            <div class="tit">
              {{ value.title }}
            </div>
            <div class="con">
              共{{ value.quantity }}部作品
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'RelatedPlayList',
  props: {
    initialData: {
      type: Array,
      default: () => [],
    },
    direction: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showMoreBtn: true,
    };
  }, // direction :across || vertical
  methods: {
    clickout(url) {
      location.href = url;
    },
  },
};
</script>

<style scoped lang="scss">
.dt-playlist {
  h3 {
    margin-top: 30px;
  }
  .dt-bodan-tit {
    padding: 0 14px;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 15px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    line-height: 21px;
  }
}

.bodan_list {
  border-top: 10px solid #f5f5f5;
}

.dt-bodan_list {
  display: flex;
}

.dt-playlist-wrap {
  padding: 0 14px;
  overflow: hidden;
  margin-bottom: 16px;
}

.dt-playlist-img {
  width: 76px;
  height: 80px;
  position: relative;
  float: left;
  margin-right: 12px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    left: 0;
    top: 0;
  }

  .img-one {
    position: absolute;
    width: 60px;
    height: 80px;
    border-radius: 3px;
    left: 0;
    top: 0;
    z-index: 3;
    overflow: hidden;
  }

  .img-two {
    position: absolute;
    width: 52px;
    height: 74px;
    border-radius: 3px;
    left: 16px;
    bottom: 0;
    z-index: 2;
    overflow: hidden;

    &:after {
      content: '';
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      opacity: 0.25;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .img-three {
    position: absolute;
    width: 46px;
    height: 68px;
    border-radius: 3px;
    left: 30px;
    bottom: 0;
    z-index: 1;
    overflow: hidden;

    &:after {
      content: '';
      width: 100%;
      height: 100%;
      background: #f5f5f5;
      opacity: 0.6;
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .tag-playlist {
    height: 18px;
    line-height: 18px;
    background: #fff;
    position: absolute;
    right: 0;
    bottom: 10px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    font-size: 11px;
    color: #222;
    z-index: 3;
    padding: 0 5px;
    font-weight: bold;
    display: none;
  }
}

.dt-playlist-info {
  .tit {
    padding-top: 8px;
    font-size: 15px;
    color: #222;
    margin-bottom: 6px;
    font-weight: bold;
    line-height: 21px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    -webkit-line-clamp: 2;
    display: block;
    display: -webkit-box;
    /*! autoprefixer: ignore next */
    -webkit-box-orient: vertical;
  }
  .con {
    font-size: 13px;
    color: #555555;
    line-height: 19px;
  }
}

.vertical-bodan-list {
  flex-direction: column;
}

.search-bodan-list {
  display: flex;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  padding-left: 14px;
  .search-dt-playlist-wrap {
    flex-shrink: 0;
    flex-grow: 0;
    padding-right: 14px;
    margin-bottom: 16px;
    width: 100%;
    box-sizing: border-box;
  }

  .dt-playlist-wrap-across {
    width: 75%;
  }

  .search-dt-playlist-wrapmultiple {
    box-sizing: border-box;
    width: 100%;
  }
}
.dt-bodan-box {
  overflow-y: hidden;
  height: 150px;
  margin-bottom: 6px;
  .dt-bodan-box-wrap {
    transform: translateY(15px);
  }
}
</style>
